import React from 'react';

class NotFoundPage extends React.Component {
  render() {
    return (
      <div>
        <div style={{textAlign: 'center', marginTop: '20px'}}>This is not the page you are looking for...</div>
      </div>
    )
  }
}

export default NotFoundPage;